var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFieldErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66406 10.7161C1.66406 6.1143 5.39555 2.38281 9.9974 2.38281C14.5998 2.38281 18.3307 6.11402 18.3307 10.7161C18.3307 15.3183 14.5998 19.0495 9.9974 19.0495C5.39555 19.0495 1.66406 15.318 1.66406 10.7161ZM17.0807 10.7161C17.0807 6.80436 13.9094 3.63281 9.9974 3.63281C6.08591 3.63281 2.91406 6.80466 2.91406 10.7161C2.91406 14.6276 6.08591 17.7995 9.9974 17.7995C13.9094 17.7995 17.0807 14.6279 17.0807 10.7161ZM9.99331 6.9279C10.3097 6.9279 10.5712 7.16302 10.6126 7.46809L10.6183 7.5529V11.2354C10.6183 11.5806 10.3385 11.8604 9.99331 11.8604C9.6769 11.8604 9.4154 11.6253 9.37402 11.3202L9.36831 11.2354V7.5529C9.36831 7.20772 9.64813 6.9279 9.99331 6.9279ZM10.6266 13.8794C10.6266 13.5342 10.3468 13.2544 10.0016 13.2544L9.9085 13.2601C9.60344 13.3015 9.36831 13.563 9.36831 13.8794C9.36831 14.2246 9.64813 14.5044 9.99331 14.5044L10.0865 14.4987C10.3915 14.4573 10.6266 14.1958 10.6266 13.8794Z",
    fill: "#CC5B5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldErrorIcon);
export default __webpack_public_path__ + "static/media/field-error-icon.179331a2dc3f7d0cf59048449b482145.svg";
export { ForwardRef as ReactComponent };